import { z } from "zod";

const PropertyRoomNightEntrySchema = z.object({
  propertyName: z.string(),
  totalRoomNight: z.string(),
});

const Top5PropertiesRoomsNightsEntrySchema = z.object({
  roundedDownTransactionDate: z.string().optional(),
  quarter: z.string(),
  month: z.string(),
  year: z.string(),
  properties: z.array(PropertyRoomNightEntrySchema),
});

export const Top5PropertiesRoomsNightsResultSchema = z.object({
  top5PropertiesRoomsNights: z.object({
    transactions: z.array(Top5PropertiesRoomsNightsEntrySchema),
  }),
});

export type Top5PropertiesRoomsNightsResult = z.infer<
  typeof Top5PropertiesRoomsNightsResultSchema
>;
